import React from 'react';
import { Table, TableBody, TableCell, TableRow, FormControlLabel, Switch } from '@mui/material';

class SettingsLoader extends React.Component {
    handleToggleMode = (event) => {
        // Call the setMode function based on the Switch's checked state
        this.props.setMode(event.target.checked ? 'dark' : 'light');
    };

    render() { 
        const { mode } = this.props;

        return ( 
            <div>
                <h2>Settings</h2>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell>Theme Mode</TableCell>
                            <TableCell>
                                <FormControlLabel
                                    control={
                                        <Switch checked={mode === 'dark'} onChange={this.handleToggleMode} />
                                    }
                                    label="Dark Mode"
                                    onClick={(event) => event.stopPropagation()} // Prevent menu close when toggling
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
        );
    }
}

export default SettingsLoader;

